import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { throwError } from 'rxjs';
import { isPublicRoute } from '../../shared/public-routes';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(private spinnerService: SpinnerService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.headers.has('X-Skip-Interceptor')) {

      return next.handle(request);
    }

    this.spinnerService.requestStarted();

    return this.handlerRequest(next, request);
    
  }

  handlerRequest(next: any, request: any) {
    return next.handle(request)
      .pipe(
        tap({
          next: (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.spinnerService.requestEnded();
            }
          }, 
          error: (err: any) => {
            if (err instanceof HttpErrorResponse && err.status === 401) {
              /* 🚫 Public PoD pages: stay put, just bubble the 401 */
              if (isPublicRoute()) {
                this.spinnerService.requestEnded();
                return throwError(() => err);
              }
          
              /* 🔐 Protected routes: go to normal auth flow */
              this.spinnerService.requestEnded();
              location.href = environment.auth_url;     // hard redirect
              return;                                   // stop further processing
            }
          
            /* Any non-401 error */
            this.spinnerService.requestEnded();
            return throwError(() => err);
          }
          
        })
      )
  }
}
